export default "__VITE_ASSET__54ba0776__"